<script>
import StoreSupportForm from '@app/components/StoreSupportForm.vue';
import StoreInformationForm from '@app/components/StoreInformationForm.vue';
import StoreOwnerPhoneForm from '@app/components/StoreOwnerPhoneForm.vue';
import StoreDisableRegistrationsForm from '@app/components/StoreDisableRegistrationsForm.vue';
import StoreCustomFieldsForm from '@app/components/StoreCustomFieldsForm.vue';
import ManageTagForm from '@app/components/ManageTagForm.vue.vue';

export default {
  head: {
    title: 'Général - Paramètres',
  },
  components: {
    StoreSupportForm,
    StoreInformationForm,
    ManageTagForm,
    StoreOwnerPhoneForm,
    StoreDisableRegistrationsForm,
    StoreCustomFieldsForm,
  },
};
</script>

<template>
  <div>
    <StoreInformationForm />
    <StoreSupportForm />
    <StoreOwnerPhoneForm />
    <ManageTagForm />
    <StoreCustomFieldsForm />
    <StoreDisableRegistrationsForm />
  </div>
</template>
